import { inject, Injectable } from '@angular/core';
import { RecaptchaService } from '@principle-theorem/ng-shared';
import {
  PATIENT_PORTAL_DISPATCHER,
  PatientAction,
  PatientActionRequest,
  type IPatient,
  type IPatientFormSchema,
  type ISubmitPatientDetailsFormRequest,
} from '@principle-theorem/principle-core/interfaces';
import {
  httpsCallable,
  serialise,
  snapshot,
  type SerialisedData,
} from '@principle-theorem/shared';

@Injectable()
export class PatientDetailsFormService {
  private _recaptcha = inject(RecaptchaService);

  async submitFormData(
    tokenUid: string,
    formData: IPatientFormSchema<Partial<IPatient>>
  ): Promise<void> {
    const data = serialise({
      tokenUid,
      data: formData,
    });

    const payload = {
      action: PatientAction.SubmitPatientDetailsForm,
      data,
      recaptchaToken: await this._recaptcha.execute(
        PatientAction.SubmitPatientDetailsForm
      ),
    };

    const request = httpsCallable<
      PatientActionRequest<SerialisedData<ISubmitPatientDetailsFormRequest>>,
      void
    >(PATIENT_PORTAL_DISPATCHER)(payload);

    await snapshot(request);
  }
}
